
import React from "react";
import { Card } from "@/components/ui/card";
import FAQsList from "./FAQsList";

const FAQModule: React.FC = () => {
  return (
    <div className="space-y-6">
      <Card className="p-6">
        <FAQsList />
      </Card>
    </div>
  );
};

export default FAQModule;
